<input type="text" 
  [disabled]="!Enabled"
  [(ngModel)]="convertedValue" 
  (keydown)="handleKeyDown($event)" 
  (blur)="onChange($event)" 
  (focus)="focus($event)" />